var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreSelectionDrawer, {
    attrs: {
      "has-search": "",
      "no-loading-search": "",
      "no-filter": "",
      title: "Город",
      placeholder: "Найти",
      value: _vm.value,
      items: _setup.cities,
      "selected-item": _vm.selectedCity,
      loading: _setup.loading,
      error: _setup.error,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", false)
      },
      back: function ($event) {
        return _vm.$emit("input", false)
      },
      "click-item": _setup.handleClickCity,
      "search:change": _setup.handleSearchChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }